import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCriticalWarning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10 10.25L10 6.75M10 14.25C10 13.6642 10 13.3358 10 12.75M8.19218 3.7665C8.98996 2.41116 11.01 2.41117 11.8078 3.7665L17.9746 14.2432C18.764 15.5842 17.7624 17.25 16.1667 17.25H3.83325C2.23756 17.25 1.23605 15.5842 2.02543 14.2432L8.19218 3.7665Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCriticalWarning);
export { ForwardRef as ReactComponent };
